import styled from "styled-components";

const Copyright = styled.p`
  color: #9701fc;
  //color: #ffffff;
  font-weight: 500;
  font-size: 15px;
  margin: auto;
`

export default Copyright
